export const config = {
    clientId: process.env.REACT_APP_APP_ID || "",
    authority: process.env.REACT_APP_AUTHORITY || "",
    redirectUri: process.env.REACT_APP_REDIRECT_URI || "https://develop.d2lbuj1tg6y8y4.amplifyapp.com",
    apiParamBack: process.env.REACT_APP_PARAME_BACK || "",
    apiAuthBack: process.env.REACT_APP_AUTH_BACK || "",
}


